
    import { Component, Vue } from 'vue-property-decorator';
    import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
    import { DataTableHeaders } from '@/types';
    import { Termin } from '@/types/Terminkalender';
    import {AnmeldungStatus} from '@/types/AnmeldungStatus';
    import moment from 'moment';
    import {TerminkalenderanmeldungenFilter} from '@/store/terminkalender';
    import User from '@/types/User';
    import AnmeldungenDetail from '@/components/AnmeldungenDetail.vue';
    import Anmeldung from '@/types/Anmeldung';
    import {VMenu} from '@/types/Components';

    @Component({
        components: {AnmeldungenDetail},
        computed: {
            ...mapGetters('authentication', ['user', 'isAllowed']),
            ...mapState('terminkalender', ['filterAnmeldung', 'anmeldungen', 'loaders', 'anmeldungDialog']),
        },
        methods: {
            ...mapActions('patient', ['loadPatient']),
            ...mapActions('terminkalender', [
                'loadTerminanmeldungen',
                'syncAnmeldungen',
            ]),
            ...mapMutations('terminkalender', ['setAnmeldungDetail']),
        },
    })
    export default class Terminanmeldungen extends Vue {
        public loadTerminanmeldungen!: (filter?: TerminkalenderanmeldungenFilter) => void;
        public syncAnmeldungen!: (filter?: TerminkalenderanmeldungenFilter) => void;
        public setAnmeldungDetail!: (visible: boolean) => void;
        public anmeldungen!: Anmeldung[];
        public zeitraumMenu = null;
        public zeitraumGebuchtMenu = null;
        public filterAnmeldung!: TerminkalenderanmeldungenFilter;
        public user!: User | null;
        public anmeldung = new Anmeldung();
        public detail = false;

        public $refs!: {
            zeitraumMenu: VMenu;
            zeitraumGebuchtMenu: VMenu;
        };

        public mounted(): void {
            this.loadTerminanmeldungen(this.filterAnmeldung);
        }

        public onClickFiltern(): void {
            this.reloadAnmeldungen();
        }

        public reloadAnmeldungen(): void {
            this.loadTerminanmeldungen(this.filterAnmeldung);
        }

        public anmeldungStatus: { text: string; value: AnmeldungStatus, divider: boolean }[] = [
            { text: 'Angelegt', value: AnmeldungStatus.Angelegt, divider: false },
            { text: 'Verarbeitet', value: AnmeldungStatus.Verarbeitet, divider: false },
            { text: 'Storniert', value: AnmeldungStatus.Storniert, divider: false },
        ];

        public get headers(): DataTableHeaders<Termin> {
            return [
                { text: '', value: 'actions', sortable: false, width: 50 },
                { text: 'gebucht', value: 'createdDisplay', sortable: false },
                { text: 'Termin', value: 'termin', sortable: false},
                { text: 'Termindauer', value: 'dauer', sortable: false},
                { text: 'Anforderung', value: 'anforderung', sortable: false },
                { text: 'Vorname', value: 'vorname', sortable: true },
                { text: 'Nachname', value: 'nachname', sortable: true },
                { text: 'SV-Nr.', value: 'svnr', sortable: false },
                { text: 'Status', value: 'statusBezeichnung', sortable: false},
                { text: 'Erreichbarkeiten', value: 'email', sortable: false },
            ];
        }

        public get maxZeitraum(): string {
            return moment().add(365, 'days').format('YYYY-MM-DD');
        }

        public get releaseDate(): string | undefined {
            return this.user?.release_date ?? undefined;
        }

        public get zeitraumLabel(): string {
            if (this.filterAnmeldung.zeitraum) {
                return this.filterAnmeldung.zeitraum.length
                    ? this.filterAnmeldung.zeitraum.sort((a: string, b: string) => a.localeCompare(b)).map((date: string) => {
                        const [year, month, day] = date.split('-');
                        return `${day}.${month}.${year}`;
                    }).join(' - ')
                    : '';
            } else return '';
        }

        public get zeitraumGebuchtLabel(): string {
            if (this.filterAnmeldung.zeitraum_gebucht) {
                return this.filterAnmeldung.zeitraum_gebucht.length
                    ? this.filterAnmeldung.zeitraum_gebucht.sort((a: string, b: string) => a.localeCompare(b)).map((date: string) => {
                        const [year, month, day] = date.split('-');
                        return `${day}.${month}.${year}`;
                    }).join(' - ')
                    : '';
            } else return '';
        }

        public onClickSynchronisieren(): void {
            this.syncAnmeldungen(this.filterAnmeldung);
        }

        public onClickEdit(anmeldung: Anmeldung): void {
            this.anmeldung = anmeldung;
            this.detail = true;
        }
    }
